import { render } from "./App.vue?vue&type=template&id=35ed79be"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35ed79be&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__